function loadView(view, module) {
  if (module) {
    return () =>
      import(
        /* webpackChunkName: "[request]" */ `@/modules/${module}/${view}.vue`
      )
  }
  return () => import(/* webpackChunkName: "[request]" */ `@/views/${view}.vue`)
}

export { loadView }
